module.exports = require("@bechtel/client-work-packages/src/detail");